import PropTypes from 'prop-types';
import React from 'react';
import { Button, ConsentTypeChoice } from '@unite-us/app-components';
import { CONSENT_OPTIONS } from 'src/components/InformedConsent/constants';
import DigitalConsentSection from './DigitalConsentSection';
import PaperAndVerbalConsentSection from './PaperAndVerbalConsentSection';

const ConsentTypeChoices = ({
  fields,
  registerField,
  onSubmit,
  selectConsentType,
  selectedConsentType,
  showConsent,
  setConsentAttestation,
  features,
  hasPlatformConsent,
  isNHConsentProvider,
  nhConsentByAttestation,
}) => {
  const sentReferrals = features.nh_consent?.referrals || [];
  const showAttestation = !isNHConsentProvider || nhConsentByAttestation;

  return (
    <div className="consent-type-choices">
      {showAttestation && (
        <div className="consent-type-choices-group attestation-consent">
          <h3 className="consent-type-choices-group__title">
            User Attestation
          </h3>
          <ConsentTypeChoice
            type={CONSENT_OPTIONS.ON_SCREEN_ATTESTATION}
            label="On-Screen Consent by Attestation (Client Consented Verbally)"
            onSelect={selectConsentType}
            selectedType={selectedConsentType}
          >
            <Button
              id="go-to-form-btn"
              className="consent-go-to-form-btn h-9 whitespace-nowrap"
              label="Go To Form"
              primary
              onClick={() => setConsentAttestation(true)}
            />
          </ConsentTypeChoice>
        </div>
      )}

      <DigitalConsentSection
        fields={fields}
        registerField={registerField}
        onSubmit={onSubmit}
        selectConsentType={selectConsentType}
        selectedConsentType={selectedConsentType}
        showConsent={showConsent}
      />

      <PaperAndVerbalConsentSection
        selectConsentType={selectConsentType}
        selectedConsentType={selectedConsentType}
        hasPlatformConsent={hasPlatformConsent}
        fields={fields}
        sentReferrals={sentReferrals}
        isNHConsentProvider={isNHConsentProvider}
      />
    </div>
  );
};

ConsentTypeChoices.propTypes = {
  fields: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  registerField: PropTypes.func.isRequired,
  setConsentAttestation: PropTypes.func.isRequired,
  selectConsentType: PropTypes.func.isRequired,
  selectedConsentType: PropTypes.string.isRequired,
  showConsent: PropTypes.func.isRequired,
  features: PropTypes.object,
  hasPlatformConsent: PropTypes.bool,
  isNHConsentProvider: PropTypes.bool,
  nhConsentByAttestation: PropTypes.bool,
};

ConsentTypeChoices.defaultProps = {
  features: {},
  hasPlatformConsent: false,
  isNHConsentProvider: false,
  nhConsentByAttestation: false,
};

export default ConsentTypeChoices;
